import { tuiDialog, TuiDialogService, TuiRoot } from '@taiga-ui/core';
import { Component, inject, TemplateRef, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faFarm,
  faPersonChalkboard,
  faHatBeach,
  faXmark,
  faUsers,
  faHome,
  faEllipsisStrokeVertical,
  faSidebar,
  faUserPlus,
  faEraser,
  faPencil,
  faPlus,
  faMinus,
  faTrash,
  faCheck,
  faChevronDown,
  faUserGroupCrown,
  faPersonToDoor,
  faUser,
  faArrowLeft,
  faArrowRight,
  faChevronLeft,
  faChevronRight,
  faCirclePlus,
  faCoffee,
  faTimesCircle,
  faCircleInfo,
  faNoteSticky,
  faTriangleExclamation,
  faBriefcase,
  faEnvelope,
  faPlusLarge,
  faBagSeedling,
  faSeedling,
  faMushroom,
  faBug,
  faHandScissors,
  faCopy,
  faChartSimple,
  faFlaskRoundPotion,
  faSpinner,
  faSquare,
  faSprayCanSparkles,
  faCog,
  faTankWater,
  faRectangleHistory,
  faUserGroup,
  faEarthOceania,
  faHistory,
  faSprinkler,
  faShower
} from '@fortawesome/duotone-regular-svg-icons';

import { NgxSonnerToaster, toast } from 'ngx-sonner';
import { AccountService } from './Auth/account.service';
import { BrnDialogService } from 'libs/dialog/brain';
import { HlmDialogComponent, HlmDialogContentComponent, HlmDialogFooterComponent, HlmDialogHeaderComponent } from 'libs/dialog/helm';
import { CreateSignatureComponent } from './shared/dialog/components/create-signature/create-signature.component';
import { filter, switchMap } from 'rxjs';
import { debug } from 'ngxtension/debug';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot, NgxSonnerToaster, HlmDialogComponent, HlmDialogContentComponent, HlmDialogHeaderComponent, HlmDialogFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'app';

  private readonly library: FaIconLibrary = inject(FaIconLibrary);

  private readonly dialog = inject(TuiDialogService);


  constructor() {
    this.library.addIcons(
      faCheck,
      faTrash,
      faMinus,
      faHome,
      faUser,
      faChevronDown,
      faCoffee,
      faChevronRight,
      faTimesCircle,
      faXmark,
      faArrowRight,
      faArrowLeft,
      faChevronLeft,
      faCircleInfo,
      faNoteSticky,
      faTriangleExclamation,
      faBriefcase,
      faEnvelope,
      faCirclePlus,
      faFarm,
      faPersonChalkboard,
      faUserGroupCrown,
      faHatBeach,
      faUsers,
      faEllipsisStrokeVertical,
      faSidebar,
      faUserPlus,
      faEraser,
      faPencil,
      faPlus,
      faPersonToDoor,
      faPlusLarge,
      faBagSeedling,
      faSeedling,
      faMushroom,
      faBug,
      faHandScissors,
      faCopy,
      faChartSimple,
      faFlaskRoundPotion,
      faSpinner,
      faSquare,
      faSprayCanSparkles,
      faEnvelope,
      faCog,
      faTankWater,
      faRectangleHistory,
      faUserGroup,
      faEarthOceania,
      faHistory,
      faSprinkler,
      faShower
    );


  }
}
